export default __webpack_public_path__ + "static/decentralization-a353d224607dd7fd18cdf4e3b65c6d26.png";